import { FILTER_TYPES } from "components/searchFilter/searchFilter";
import { PARTY_AGGREGATION_LEVEL } from "constants/common";

const PARTY_SEARCH_TYPE_OPTIONS = [
  {
    key: "partyName",
    displayName: "Account Name",
    type: FILTER_TYPES.INPUT,
  },
  {
    key: "productName",
    displayName: "Product Name",
    type: FILTER_TYPES.INPUT,
  },
  {
    key: "partyId",
    displayName: "Account Number",
    type: FILTER_TYPES.INPUT,
    regex: "^[0-9-]*$",
  },
];

export const getSearchTypeOptions = (partyAggregationLevel) => {
  if (partyAggregationLevel === PARTY_AGGREGATION_LEVEL.PRODUCT) {
    return PARTY_SEARCH_TYPE_OPTIONS.filter(({ key }) => key !== "productName");
  }
  return PARTY_SEARCH_TYPE_OPTIONS;
};
